import $ from "jquery";

const switchFontSize = (switchValue) => {

    switch (switchValue) {
        case "sehr_gross":
            $("body").removeClass("zoomToGross").addClass("zoomToSehrGross");
            break;
        case "gross":
            $("body").removeClass("zoomToSehrGross").addClass("zoomToGross");
            break;
        case "normal":
        default:
            $("body").removeClass("zoomToSehrGross zoomToGross");
    }
}

export const initDisplaySettings = () => {

    const loadedFontSize = localStorage.getItem("fontSize");
    $('input:radio[name="font-size"][value="' + loadedFontSize + '"]').attr('checked', true);
    switchFontSize(loadedFontSize)

    $(function () {
        const SETTINGS_TRIGGER = ".header-menu .menu-items .menu-item.settings";
        const SETTINGS_CLOSE = ".header-menu .menu-items .menu-item.settings-close";
        const SETTINGS_ELEMENT = ".display-settings";
        const BLUR_ELEMENT = "#content";
        const MENU_ITEM = ".header-menu .menu-items .menu-item.menu";
        const CONTRAST_INPUT = ".display-settings .settings-container .settings .contrast input";
        const FONT_SIZE_INPUT = ".display-settings .settings-container .settings .font-size input";

        const closeSettings = () => {
            $([SETTINGS_ELEMENT, SETTINGS_CLOSE, MENU_ITEM].join(",")).toggleClass("hidden");
            $(BLUR_ELEMENT).toggleClass("blur");
        };

        $([SETTINGS_TRIGGER, SETTINGS_CLOSE].join(",")).click(closeSettings);

        $(document).mouseup(function (e) {
            const settings = $(SETTINGS_ELEMENT);
            if (
                !settings.is(e.target) &&
                settings.has(e.target).length === 0 &&
                !$(SETTINGS_ELEMENT).hasClass("hidden")
            ) {
                closeSettings();
            }
        });

        $(CONTRAST_INPUT).click(function () {
            const contrast = $(this).prop("value");
            //console.log("asdasd", contrast);
            switch (contrast) {
                case "hoch":
                    $("body").removeClass("contrast-invertiert").addClass("contrast-hoch");
                    break;
                case "invertiert":
                    $("body").removeClass("contrast-high").addClass("contrast-invertiert");
                    break;
                case "normal":
                default:
                    $("body").removeClass("contrast-hoch contrast-invertiert");

            }
        });

        $(FONT_SIZE_INPUT).click(function () {

            const fontSize = $(this).prop("value");
            localStorage.setItem("fontSize", fontSize);

            switchFontSize(fontSize)

        });

    });
}


